// extracted by mini-css-extract-plugin
export default {"container":"roomCard_container__hfUOF","item":"roomCard_item__7zQdi","info":"roomCard_info__4IqcW","price":"roomCard_price__IURDz","btn":"roomCard_btn__hwUeM"};